document.addEventListener("DOMContentLoaded", injectDonationButton );

// Injects the Donation button globally into the page body/footer
function injectDonationButton(){

    const template = document.getElementById('donation-iframe-button');

    // If the template doesn't exist on this page (e.g. turned off in ACF options), stop here.
    if ( ! template ) return;

    // Clone the button HTML from the template
    const htmlElement = template.content.cloneNode(true);
    
    // Append it directly to the body so it sits globally at the root level
    document.body.appendChild(htmlElement);

    // Grab the newly injected button and attach the click event listener
    const button = document.getElementById('donation-button');
    if ( button ) {
        button.addEventListener('click', handleDonationButtonClick);
    }
}

// Open the popup
function handleDonationButtonClick(e){

    let popup = document.getElementById('donation-iframe');

    if( ! popup ) return;
    
    popup.style.display = 'block';
    popup.style.opacity = 0;

    setTimeout( () => popup.style.opacity = 1 , 50);
    
    popup.querySelector('.donation-iframe--blocker').addEventListener('click', handleDonationBlockerClick )
    window.addEventListener('keydown', handleDonationKeyboardInput );
    
}

// When user clicks the black background
function handleDonationBlockerClick(){
    closeDonationPopup();
}

// when user press keyboard Esc key
function handleDonationKeyboardInput(e){
    if( e.key !== "Escape" ) return;
    closeDonationPopup();
}

// Close Popup
function closeDonationPopup(){

    let popup = document.getElementById('donation-iframe');

    if( ! popup ) return;
        
    popup.style.opacity = 0;
    
    setTimeout( () => popup.style.display = 'none', 250);

    popup.querySelector('.donation-iframe--blocker').removeEventListener('click', handleDonationBlockerClick );
    // FIX: Changed from addEventListener to removeEventListener to clean up memory
    window.removeEventListener('keydown', handleDonationKeyboardInput ); 
}